import styled from "styled-components";

import { Grid, Accordion } from "@mui/material";
import CustomLink from '../../components/CustomLink/CustomLink.jsx';

import BannerImg from "../../assets/cangoo-faq-banner.jpg"

export const BannerGrid = styled(Grid)`
background: url(${BannerImg});
background-repeat: no-repeat;
background-position: top center; 
background-size: cover; 

padding-bottom: 10rem;
padding-top: 24rem;

@keyframes fadeIn {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

.title {
    position: relative;
    width: fit-content;
    display: flex;
 
    margin-left: 10rem;
    animation: fadeIn 2s ease-in-out;


    h1 {
        font-family: 'Nexa-Black'; 
        font-size: 8rem;
        color: ${({ theme }) => theme.COLORS.WHITE};
        letter-spacing: 1px;
        padding-right: 4rem;
        padding-bottom: 4rem;

        line-height: 10rem;
    }

    img {
        width: 15rem;
        position: absolute;
        right: 0;
        bottom: 0;
      
    }
}


@media (max-width: 1400px) {
    padding-top: 20rem;
    padding-bottom: 6rem;

   .title {

    h1 { 
        font-size: 5rem;
        padding-right: 3rem;
        padding-bottom: 3rem;

        line-height: 6rem;
    }

    img {
        width: 10rem;  
        bottom: 0;
    }
   }
  }
 
  @media (max-width: 900px) {
    padding-top: 20rem;
    padding-bottom: 6rem;

   .title {
    margin-left: auto;
    margin-right: auto;    

    h1 { 
        font-size: 4rem;
        padding-right: 3rem;
        padding-bottom: 2rem;

        line-height: 6rem;
    }

    img {
        width: 8rem;  
    }
   }
  }
`;

export const SectionGrid = styled(Grid)`
padding:10rem 20rem;
padding-bottom: 0;
animation: fadeIn 1s ease-in-out;


h1 {
        font-size: clamp(2.4rem, 4vw, 8rem); 
        font-family: 'Nexa-Bold';
        letter-spacing: 1px;
        color: ${({ theme }) => theme.COLORS.LIGHTBLUE2};
  }

  p {
    font-family: 'Mont-Light';
    font-size: clamp(1.6rem, 3.4vw, 3rem); 
    color: ${({ theme }) => theme.COLORS.BLUE};
    margin-bottom: 8rem;
    margin-top: 4rem;
  }

  span {
    font-family: 'Mont-Medium';
    font-size: clamp(1.6rem, 3.4vw, 3rem); 
    color: ${({ theme }) => theme.COLORS.YELLOW};
  }

  a {
    display: block;
    margin-left: auto;
    margin-right: auto;
    width: fit-content;
    background-color: ${({ theme }) => theme.COLORS.YELLOW};
   
    padding: 2rem 4rem;
    border-radius: 999px; 

    transition: all .2s;
  }

  .button {
    color: ${({ theme }) => theme.COLORS.LIGHTBLUE2};
  }

  a:hover {
    background-color: ${({ theme }) => theme.COLORS.LIGHTBLUE2};
  }

  a:hover .button{
    color: ${({ theme }) => theme.COLORS.YELLOW};
  }


  @media (max-width: 1400px) {
    padding:10rem 16rem;
    padding-bottom: 0;

    h1 {
        font-size: clamp(2.6rem, 3.4vw, 5rem);
    }

    span {
        font-size: clamp(1.8rem, 3.4vw, 2.2rem);
    }

    p {
        font-size: clamp(1.8rem, 3.4vw, 2.2rem); 
    }
}


@media (max-width: 1200px) {
  padding:10rem 10rem;
  padding-bottom: 0;
}

@media (max-width: 900px) {
  padding:10rem 2rem;
  padding-bottom: 0;
  text-align: center;

  a {
    padding: 1.6rem;
  }

  .button {
    font-size: 1.5rem;
  }
}

@media (max-width: 600px) {
  padding-top: 6rem;
}

`;

export const FAQGrid = styled(Grid)`
padding:10rem;

.texto-inicial {
    h1 {
        font-size: clamp(2.6rem, 4vw, 8rem); 
        font-family: 'Nexa-Bold';
        letter-spacing: 1px;
        color: ${({ theme }) => theme.COLORS.LIGHTBLUE2};
  }

  p {
    font-family: 'Mont-Medium';
    font-size: clamp(1.8rem, 3.4vw, 3rem); 
    color: ${({ theme }) => theme.COLORS.BLUE};
    margin-bottom: 6rem;
    margin-top: 4rem;
  }
  }


@media (max-width: 1400px) {
  .texto-inicial {
    h1 {
        font-size: clamp(2.6rem, 3.4vw, 5rem);
    }

    p {
        font-size: clamp(1.8rem, 3.4vw, 2.2rem); 
    }
  }
}

@media (max-width: 900px) {
  padding: 10rem 2rem;

  .texto-inicial {
    text-align: center;
  }
}

`;


export const FAQAccordion = styled(Accordion)`
  width: 100%;
  border-radius: 0 !important;
  background-color: ${({ theme }) => theme.COLORS.GREY} !important;
  color: ${({ theme }) => theme.COLORS.BLUE} !important;
  padding-top: 3rem;
  padding-left: 3rem;
  padding-bottom: 3rem;

  margin-bottom: 1rem;


  h1 {
    font-family: 'Mont-Bold';
    font-size: clamp(2rem, 3vw, 3.4rem);
    padding-right: 1.2rem;
  }

  p, a {
    font-family: 'Mont-Light';
    font-size: clamp(1.6rem, 3.4vw, 3rem);
    padding-right: 3rem;
    color: ${({ theme }) => theme.COLORS.WHITE};
  }

  a {
    padding: 0;
  }

  a:hover {
    color: ${({ theme }) => theme.COLORS.YELLOW}
  }

  span {
    cursor: pointer;
    font-family: 'Mont-Medium';
    font-size: clamp(1.6rem, 3.4vw, 3rem);

    color: ${({ theme }) => theme.COLORS.YELLOW}
  }

  span:hover {
    color: ${({ theme }) => theme.COLORS.WHITE}
  }

  .MuiAccordionSummary-root img {
    width: clamp(2.6rem, 6vw, 5rem);
  }


  &.Mui-expanded {
    background-color: ${({ theme }) => theme.COLORS.LIGHTBLUE2} !important;
    color: ${({ theme }) => theme.COLORS.WHITE} !important;

    .MuiAccordionSummary-root img {
        filter: brightness(1.2) saturate(120%) hue-rotate(220deg);    }
  }


  @media (max-width: 1400px) {
    h1 {
      font-size: clamp(2rem, 3vw, 2.6rem);
    }

    p, a, span {
        font-size: clamp(1.6rem, 3.4vw, 2.2rem); 
    }
  }


  @media (max-width: 900px) {
    padding-top: 1.2rem;
    padding-left: 1.2rem;
    padding-bottom: 1.2rem;

  p {
    padding-right: 1.2rem;
  }
  }
`;

export const StyledLink = styled(CustomLink)`
 text-decoration: none !important;
`;

export const FormGrid = styled(Grid)`
 padding-bottom: 10rem;
 padding-left: 10rem;

.sideA {
display: flex;
flex-direction: column;
justify-content: center;

.form-content {
      padding: 0 10rem;
    }

  .form-text {
    margin-bottom: 2rem;
    margin-left: auto;
    margin-right: auto;
    width: fit-content;


    h1 {
        font-size: clamp(2.4rem, 3.4vw, 5.2rem); 
        font-family: 'Nexa-Bold';
        margin-bottom: 1.8rem;
        letter-spacing: 1px;
        color: ${({ theme }) => theme.COLORS.LIGHTBLUE2};
    }

    p {
        font-family: 'Mont-Light';
        font-size: clamp(1.6rem, 3.4vw, 2.4rem); 
    }
}
}


.sideB {
    display: flex;
    justify-content: center;
    align-items: center;


    img {
        width: clamp(30rem, 36vw, 70rem); 
    }
}


@media (max-width: 1400px) {
  padding-bottom: 10rem;
  padding-left: 6rem;
  

  .sideA {
    .form-content {
      padding: 0 4rem;
    }

    .form-text {

h1 {
    font-size: clamp(2.6rem, 3.4vw, 4.2rem); 
    margin-bottom: 1rem;
}

p {
    font-size: clamp(1.8rem, 3.4vw, 2.2rem); 
}
}
  }
}



@media (max-width: 900px) {
  padding-bottom: 10rem;
  padding-left: 0;
  padding-right: 0;
  

  .sideA {
    padding: 0 4rem;

    .form-content {
      padding: 0;
    }

    .form-text {
      text-align: center;
}
  }


  .sideB {
    margin-top: 6rem;
  }
}


@media (max-width: 600px) {
  .sideA {
      padding: 0 2rem;
    }
}


`;





